const Dynpack = require('od-apps/app.dynpack');
const trackingUtils = require('od-modules/utils/tracking.utils');
const UiGoogleMap = require('od-modules/helpers/map/ui/hotel_result_list');
const commonParser = require('od-modules/parsers/dynpack_common');
const {trackClickEvent} = require('od-modules/track_events/track.frontevents.utils');
const TRACKING_ACTIONS = {
    accommodationResultsMap: 'results_list_hotels_map',
    accommodationResults: 'results_list_hotels',
    accommodationClick: 'hotel_click',
};
const TRACKING_LABELS = {
    openMap: 'map_open_all_hotels',
    clickCluster: 'map_click_bubble',
    clickMarkerPreselected: 'map_hotel_star',
};
const GALLERY_OPTIONS = {
    isRotationDisabled: true,
    isDraggable: false,
    isFullViewCarousel: false,
};
const MAP_OPTIONS = {
    offsetHeight: 60,
    delayOnUpdate: 3000,
};
const ADDONS_OPTIONS = {
    clusterCustomConfig: {
        minimumClusterSize: 5,
    },
    infoWindowOptions: {
        disableAutoPan: true,
    },
};

function updateAfterIdleEventMap() {
    return Odigeo._.after(!$.fx.muted && 2, Odigeo._.bind(this.update, this));
}

function hasToCloseHotelInfoOnUserAction(userTarget) {
    return this.mapMngr.isInfoWindowOpen() &&
        !this.mapMngr.hasDragInteraction &&
        hasSelectedUserActions.call(this, userTarget);
}

function hasSelectedUserActions(userTarget) {
    return !this.mapMngr.hasSelectedMarkerCluster(userTarget) &&
        (this.absConfig.hasToggleMarkerButtons || !this.mapMngr.hasSelectedGoogleMapControls(userTarget)) &&
        !this.mapMngr.hasHotelInfoElement(userTarget);
}

function hasToCenterHotelInfoOnUserAction(userTarget) {
    return this.mapMngr.isInfoWindowOpen() &&
        (this.mapMngr.hasSelectedMarkerCluster(userTarget) || this.mapMngr.hasSelectedGoogleMapControls(userTarget));
}

const EVENTS_MULTITAB = {
    'tap .accommodationmap_body': 'onSelectAccommodation',
};
const EVENTS_NO_MULTITAB = {
    'tap @toggleDetails': 'accommodationToggleDetails',
    'tap .select_accommodation:not(.selected)': 'onSelectAccommodation',
    'tap .continue_without_prime': 'onSelectAccommodation',
};

module.exports = Odigeo.View.extend({
    selectors: {
        toggleDetails: '.accommodation_toggle_details',
        mapDetailsContainer: '.accommodation_details_super_container',
        mapTooltipContainer: '.accommodation_map_tooltip',
        mapContainer: '.accommodation_map_container',
        detailsContainer: '.accommodation_details',
        mapAddress: '.accommodationmap_address',
        mapPostalCode: '.accommodationmap_postalCode',
        mapGalleryImage: '.accommodationmap_galleryImage',
    },

    events: Object.assign({
        'tap .accommodation_close_hotelmapbox': 'closeHotelInfo',
    }, Odigeo.AB.isDynpackDesktopMultiTab ? EVENTS_MULTITAB : EVENTS_NO_MULTITAB),

    tmpls: {},

    containerHeight: 0,

    showPrices: true,

    absConfig: null,

    mapMngr: null,

    mapEvents: null,

    isUpdatedOnSearchResults: false,

    handleIdEvents: {
        'resize.openHotelInfoByKey': 0,
        'loadedWindow.centerMarkerPosition': 0,
    },

    init() {
        this.listenToOnce(this.model, 'update_map', Odigeo._.bind(this.firstUpdate, this));
        this.listenTo(this.model, 'update_map', updateAfterIdleEventMap.call(this));
    },

    async firstUpdate() {
        this.absConfig = {
            hasTooltipTemplate: true,
            hasTopVisibilityMarkerPreselected: this.widget.options.preselectedMarkerIcon,
            hasToggleMarkerButtons: false,
        };
        this.mapMngr = new UiGoogleMap(Odigeo._.extend({
            templates: this.tmpls,
            absConfig: this.absConfig,
            removeHotelInfoMapListener: this.absConfig.hasTooltipTemplate,
            fullscreenControl: false,
        }, this.widget.options, ADDONS_OPTIONS));
        await this.mapMngr.isReady;
        this.mapMngr.startMap({
            mapDiv: this.$cachedSelectors.mapContainer.get(0),
            btnGroupCbk: Odigeo._.bind(this.changeMarkers, this),
        });
        this.mapEvents = this.mapMngr.events.getListeners();
        this.bindMapEvents();
    },

    update() {
        this.mapMngr.setHasUserInteraction(false);
        this.model.publishMarkers(this.refreshMap());
        Odigeo._.delay(Odigeo._.bind(this.resizeMap, this), (this.isUpdatedOnSearchResults && !$.fx.muted) ? MAP_OPTIONS.delayOnUpdate : 0);

        if (!this.mapMngr.hasMarkers()) {
            this.close();
        }
    },

    setContainerHeight(height) {
        this.containerHeight = height;
    },

    changeMarkers(eventData) {
        if (!Odigeo._.isEqual(eventData.showPrices, this.showPrices)) {
            this.showPrices = eventData.showPrices;
            this.refreshMap();
        }
    },

    toggle(evt) {
        this.toggleMap(evt, !this.isMapOpened());
    },

    toggleMap(evt, hasToOpen) {
        if (hasToOpen) {
            this.openMap(evt);
        } else {
            this.close();
        }
    },

    openMap(evt) {
        if (this.mapMngr.events.hasMouseAction(evt)) {
            Odigeo.trigger(this.widget.id + ':openMapWithScrollAndResize');
        } else if (this.isUpdatedOnSearchResults) {
            this.open();
        } else {
            Odigeo.trigger(this.widget.id + ':openMapAndResize');
        }
    },

    toggleAnimation(height, cbToggle) {
        return this.$cachedSelectors.mapContainer
            .clearQueue()
            .height(height)
            .delay(!$.fx.muted && 400) // .od-accommodationmap height transition duration
            .queue(Odigeo._.bind(cbToggle, this));
    },

    isMapOpened() {
        return this.$cachedSelectors.mapDetailsContainer.hasClass('map-opened');
    },

    open() {
        return this.toggleAnimation(this.getCalculatedHeight(), function(next) {
            this.mapMngr.setHasUserInteraction(false);
            this.$cachedSelectors.mapDetailsContainer.addClass('map-opened').removeClass('map-closed');

            if (this.absConfig.hasTooltipTemplate) {
                this.bindOnResizeMapOpenHotelInfo();
                this.bindOnLoadedInfoWindowCenterPosition();
            }
            this.resizeMap();
            trackingUtils.trackEvent(TRACKING_ACTIONS.accommodationResults, TRACKING_LABELS.openMap);
            Odigeo.trigger(this.widget.id + ':toggleMapStatus', true);
            next();
        });
    },

    close() {
        return this.toggleAnimation(0, function(next) {
            this.$cachedSelectors.mapDetailsContainer.removeClass('map-opened loaded').addClass('map-closed');
            Odigeo.trigger(this.widget.id + ':toggleMapStatus', false);
            next();
        });
    },

    getCalculatedHeight() {
        let height = this.containerHeight - MAP_OPTIONS.offsetHeight;
        let hasToResizeMap = height > this.widget.options.minHeight;

        return hasToResizeMap ? height : this.widget.options.minHeight;
    },

    closeHotelInfo() {
        this.mapMngr.closeHotelInfo();
    },

    refreshMap() {
        return this.mapMngr.refresh({
            dataMarkers: this.model.toJSON(),
            isCustomMarker: this.showPrices,
            preselectedMarkerIcon: this.widget.options.preselectedMarkerIcon,
        });
    },

    resizeMap() {
        this.isUpdatedOnSearchResults = false;
        if (this.isMapOpened()) {
            this.mapMngr.resizeMap({
                hasLoadedMap: true,
            });
        }
    },

    bindMapEvents() {
        let infoWindow = this.mapMngr.getInfoWindow();

        this.mapEvents.listenToOnce(this.mapMngr.map, {
            'idle': Odigeo._.bind(this.update, this),
        });
        this.mapEvents.listenTo(this.mapMngr.map, {
            'idle': Odigeo._.bind(function() {
                if (!this.mapMngr.hasUserInteraction) {
                    this.mapMngr.resizeMap();
                }
                this.mapMngr.setHasUserInteraction(true);
            }, this),
            'resize': Odigeo._.bind(function(options) {
                this.mapMngr.refreshBounds();
                this.$cachedSelectors.mapDetailsContainer.addClass(function() {
                    return Odigeo._.isObject(options) && options.hasLoadedMap && 'loaded';
                });
            }, this),
            'dragend.setDragInteraction': Odigeo._.bind(function() {
                this.mapMngr.setHasDragInteraction(this.mapMngr.isInfoWindowOpen());
            }, this),
        });
        this.mapEvents.listenToDom(this.mapMngr.map.getDiv(), {
            'click.closeInfoWindow': Odigeo._.bind(this.preventCloseInfoWindow, this),
            'dblclick.closeInfoWindow': Odigeo._.bind(this.preventCloseInfoWindow, this),
            'click.activeMap': Odigeo._.partial(this.mapMngr.setHasUserInteraction, true),
        });
        this.mapEvents.listenTo(infoWindow, {
            'openWindowByClickOnMarker': Odigeo._.bind(this.trackEventMapOnClickMarker, this),
            'loadedWindow.openWindowByClickOnMarker': Odigeo._.bind(
                this.absConfig.hasTooltipTemplate ? this.centerMarkerPosition : Odigeo._.noop,
                this
            ),
            'loadedWindow.updateHotelInfoDetails': Odigeo._.bind(
                this.absConfig.hasTooltipTemplate ? this.updateHotelInfoDetails : Odigeo._.noop,
                this
            ),
            'loadedWindow.repositionHotelInfo': Odigeo._.bind(this.repositionHotelInfo, this),
            'loadedWindow.showHotelInfoTooltip': Odigeo._.bind(this.absConfig.hasTooltipTemplate ? this.showHotelInfoTooltip : Odigeo._.noop, this),
            'clickCluster': this.onClusterClick.bind(this),
        });
    },

    preventCloseInfoWindow(evt) {
        if (hasToCloseHotelInfoOnUserAction.call(this, evt.target)) {
            this.mapMngr.closeHotelInfo();
        }

        if (this.absConfig.hasTooltipTemplate && hasToCenterHotelInfoOnUserAction.call(this, evt.target)) {
            this.mapMngr.centerHotelInfoPosition();
        }

        this.mapMngr.setHasDragInteraction(false);
    },

    accommodationToggleDetails: function(evt) {
        let $target = $(evt.currentTarget);
        let isOpenHotelDetails = this.$cachedSelectors.detailsContainer.hasClass('open');

        evt.stopPropagation();
        Odigeo.trigger(this.widget.id + ':toggleDetails', $target.data('details'));

        if (!isOpenHotelDetails) {
            trackingUtils.trackEvent(TRACKING_ACTIONS.accommodationResultsMap, $target.data('label'));
        }
    },

    onSelectAccommodation(evt) {
        const key = $(evt.currentTarget).data('key');
        const accommodation = this.mapMngr.getMarkerByKey(key.toString()).dataMarker;
        const label = commonParser.buildHotelSelectOrClickLabel(accommodation, 'hotel_select', 'map');
        const tracking = {action: TRACKING_ACTIONS.accommodationResultsMap, label};
        const providerId = accommodation.accommodationDeal.providerId;

        evt.stopPropagation();
        Odigeo.trigger(`${this.widget.id}:trackOnSelectAccommodation`, tracking);
        trackingUtils.trackEventWithCategory('dynpack_hotel_results', 'results_list_hotels', `hotel_select_map_provider:${providerId}`);

        if (Odigeo.AB.isDynpackDesktopMultiTab) {
            Dynpack.openHotelPageTab(accommodation.accommodationDeal, 'general-map');
        } else {
            Odigeo.trigger(`${this.widget.id}:selectAccommodation`,
                {...accommodation.accommodationDeal, priceWithoutDiscountSelected: $(evt.currentTarget).is('.continue_without_prime')}
            );
        }
        this.repositionHotelInfo();
        trackClickEvent(evt);
    },

    onClusterClick() {
        trackingUtils.trackEvent(TRACKING_ACTIONS.accommodationResults, TRACKING_LABELS.clickCluster);
    },

    repositionHotelInfo() {
        Odigeo.trigger(this.widget.id + ':centerMapToViewport');
        Odigeo.trigger(this.widget.id + ':closeDetails');
    },

    trackEventMapOnClickMarker(dataMarker) {
        const label = dataMarker.preselected
            ? TRACKING_LABELS.clickMarkerPreselected
            : commonParser.buildHotelSelectOrClickLabel(dataMarker, TRACKING_ACTIONS.accommodationClick, 'map');
        trackingUtils.trackEvent('results_list_hotels_map', label);
    },

    bindOnResizeMapOpenHotelInfo() {
        const preselectedMarker = this.mapMngr.getMarkerByPreselectedKey();
        const isPreselectedHotelPresentInMap = () => !Odigeo._.isUndefined(Odigeo._.get(preselectedMarker, 'dataMarker.accommodationDealKey'));

        if (this.isMapOpened() && isPreselectedHotelPresentInMap()) {
            const handle = this.mapEvents.listenTo(this.mapMngr.map, {
                'resize.openHotelInfoByKey': () => this.openHotelInfoByKey(preselectedMarker.dataMarker.accommodationDealKey),
            });
            Odigeo._.extend(this.handleIdEvents, handle);
        }
    },

    bindOnLoadedInfoWindowCenterPosition() {
        const handle = this.mapEvents.listenTo(this.mapMngr.getInfoWindow(), {
            'loadedWindow.centerMarkerPosition': () => this.centerMarkerPosition(),
        });
        Odigeo._.extend(this.handleIdEvents, handle);
    },

    centerMarkerPosition() {
        this.mapEvents.removeListener(this.handleIdEvents['loadedWindow.centerMarkerPosition']);
        this.mapMngr.centerMarkerPosition();
    },

    openHotelInfoByKey(markerKey) {
        this.mapEvents.removeListener(this.handleIdEvents['resize.openHotelInfoByKey']);
        this.mapMngr.openInfoWindowByMarker(this.mapMngr.getMarkerByKey(markerKey));
    },

    updateHotelInfoDetails(marker) {
        let markerKey = Odigeo._.get(marker, 'dataMarker.accommodationDealKey');

        if (Odigeo._.isEmpty(marker.dataMarker.accommodationImages)) {
            this.model.updateDetails(markerKey)
                .then((details) => {
                    this.mapMngr.setDataMarker(markerKey, 'accommodationImages', details.accommodationImages);
                    this.mapMngr.setDataMarker(markerKey, 'postalCode', details.postalCode);
                })
                .then(() => this.mapMngr.setGalleryImageMarker(markerKey, GALLERY_OPTIONS))
                .then(() => this.printHotelInfoDetails(markerKey));
        } else {
            this.printHotelInfoDetails(markerKey);
        }
    },

    printHotelInfoDetails(markerKey) {
        if (this.$el.find(this.selectors.mapTooltipContainer).data('key') === parseInt(markerKey, 10)) {
            let hotelDetails = this.mapMngr.pickDataMarker(markerKey, ['postalCode', 'galleryImage']);

            this.$el.find(this.selectors.mapPostalCode).html(hotelDetails.postalCode).show();
            this.$el.find(this.selectors.mapGalleryImage).html(hotelDetails.galleryImage).fadeIn(!$.fx.muted ? 1000 : 0);
        }
    },

    showHotelInfoTooltip() {
        this.$el.find(this.selectors.mapTooltipContainer).addClass('loaded');
    },
});
